import React from "react";
import PropTypes from "prop-types";
import { SFStack } from "../../../grid";
import ButtonAction from "../../renderers/button";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const ButtonActionGroupWrapper = styled(SFStack)(({ theme }) => ({
  height: "48px",
  padding: "0px 10px",
  borderLeft: `1px solid ${theme.palette.grey100.main}`,
}));

const ButtonActionGroup = ({ actionDefs = [], disableTooltip = false }) => {
  if (actionDefs.length === 0) {
    // If there are no button action definitions, return null
    return null;
  }

  return (
    <ButtonActionGroupWrapper
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
    >
      {actionDefs.map((actionDef, index) => (
        <ButtonAction key={index} actionDef={actionDef} disableTooltip={disableTooltip} />
      ))}
    </ButtonActionGroupWrapper>
  );
};

export default ButtonActionGroup;

ButtonActionGroup.propTypes = {
  actionDefs: PropTypes.arrayOf(
    PropTypes.shape({
      // The name of the action
      name: PropTypes.string.isRequired,
      // The function to call when the button is clicked
      onClick: PropTypes.func.isRequired,
      // The props to pass to the button
      buttonProps: PropTypes.shape({
        // The label of the button
        label: PropTypes.string.isRequired,
        // The icon to display on the button
        icon: PropTypes.element,
        // The icon placement of the button
        iconPlacement: PropTypes.oneOf(["start", "end"]),
        // The variant of the button
        variant: PropTypes.oneOf(["primary", "secondary", "utility"]),
      }),
    })
  ),
};
